import { authApiCall } from "../../auth";

// GET EMAIL TEMPLATES
export const getEmailTemplates = () =>
  authApiCall({
    url: `/email/`,
    method: "get",
  });

// CREATE EMAIL TEMPLATE
export const createEmailTemplate = (payload) =>
  authApiCall({
    url: `/email/`,
    method: "post",
    data: payload,
  });

// UPDATE EMAIL TEMPLATE
export const updateEmailTemplate = (id, payload) =>
  authApiCall({
    url: `/email/${id}/`,
    method: "put",
    data: payload,
  });

// SEND TEST EMAIL
// API endpoint intentionally left as placeholder for now.
export const sendTestEmail = (payload) =>
  authApiCall({
    url: `/email/send-test-email/`,
    method: "post",
    data: payload,
  });

  // SEND EMAIL
export const sendEmails = (payload) =>
  authApiCall({
    url: `/email/send-emails/`,
    method: "post",
    data: payload,
  });